// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__28kEZ","loading":"styles_loading__1SfDX","formShell":"styles_formShell__16_FZ"};